<template>
    <div>
        <v-dialog
            v-model="display"
            width="350">
            <PrintDialogSkeleton v-if="loading.data"/>
            <v-card v-else flat>
                <v-card-title>
                    {{ $t('print') }}
                    <v-spacer></v-spacer>
                    <v-switch v-model="showQuantityFlow" :label="$t('with_quantity_flow')"></v-switch>
                    <v-switch v-model="showInvoicesLines" :label="$t('sales')"></v-switch>
                </v-card-title>
                <v-card-text>
                    {{ $t('print_msg_statement') }}
                    <div :id="printNumber" style="display: none"  >
                        <div>
                            <div class="row">
                                <div class="col-sm">
                                    <div class="text-left">
                                        <h4>Petra Ready Mixed Concrete</h4>
                                        <h4><p>Customer Statement</p></h4>
                                        <p>khartoum - sudan Industrial Area, Gabra Square. +249912809360-+249187114000</p>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-sm">
                                    <h5 class="text-left">{{ $t('title_info') }} :</h5>
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th>{{ $t('code') }}</th>
                                                <td>{{ statement.customer_code }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('customer') }}</th>
                                                <td>{{ statement.customer_name }}</td>
                                            </tr>
                                            <tr>
                                                <th>{{ $t('phone') }}</th>
                                                <td>{{ statement.customer_phone }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm">
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th width="100px">Date</th>
                                                <th width="140px">Transaction</th>
                                                <th width="120px">Trans.No</th>
                                                <th>Description</th>
                                                <th>Debit</th>
                                                <th>Credit</th>
                                                <th>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colspan="6">{{ statement.opening_balance.description }}</td>
                                                <td>{{ formatPrice(statement.opening_balance.balance) }}</td>
                                            </tr>
                                            <tr v-for="trans in statement.transactions" :key="trans.transaction_id">
                                                <td width="130">{{ trans.date }}</td>
                                                <td>{{ trans.transaction }}</td>
                                                <td>{{ trans.transaction_code }}</td>
                                                <td>{{ trans.description }}</td>
                                                <td>{{ formatPrice(trans.debit) }}</td>
                                                <td>{{ formatPrice(trans.credit) }}</td>
                                                <td>{{ formatPrice(trans.balance) }}</td>
                                            </tr>
                                            <tr>
                                                <th colspan="4">{{ statement.ending_balance.description }}</th>
                                                <th>{{ formatPrice(statement.ending_balance.debit) }}</th>
                                                <th>{{ formatPrice(statement.ending_balance.credit) }}</th>
                                                <th>{{ formatPrice(statement.ending_balance.balance) }}</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div v-if="showQuantityFlow" class="row">
                                <div class="col-sm">
                                    <h5 class="text-left">{{ $t('delivery_status_report') }} :</h5>
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>{{this.$t('sales_order_code')}}</th>
                                                <th>{{this.$t('date')}}</th>
                                                <th>{{this.$t('validity_date')}}</th>
                                                <th>{{this.$t('item_name')}}</th>
                                                <th>{{this.$t('quantity')}}</th>
                                                <th>{{this.$t('price')}}</th>
                                                <th>{{this.$t('delivered')}}</th>
                                                <th>{{this.$t('remaining')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="salesOrder in customerSalesOrders" :key="salesOrder.id">
                                                <td>{{ salesOrder.sales_order_code }}</td>
                                                <td>{{ salesOrder.sales_order_date }}</td>
                                                <td>{{ salesOrder.sales_order_validity_date}}</td>
                                                <td>{{ salesOrder.item }}</td>
                                                <td>{{ salesOrder.quantity }}</td>
                                                <td>{{ formatPrice(salesOrder.price) }}</td>
                                                <td>{{ salesOrder.delivered }}</td>
                                                <td>{{ salesOrder.remaining }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <br>
                            <br>
                            <!-- Invoice Lines -->
                            <div class="row" v-if="showInvoicesLines">
                                <div class="col-sm">
                                    <h5 class="text-left">{{ $t('sales') }} :</h5>
                                    <table style="border-collapse: collapse; border: none;" class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>{{this.$t("code")}}</th>
                                                <th>{{this.$t('date')}}</th>
                                                <th>{{this.$t('item_name')}}</th>
                                                <th>{{this.$t('quantity')}}</th>
                                                <th>{{this.$t('price')}}</th>
                                                <th>{{this.$t('total')}}</th>
                                                <th>{{this.$t('site')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="record in invoicesLines" :key="record.id">
                                                <td>{{ record.invoice_code }}</td>
                                                <td>{{ record.invoice_date }}</td>
                                                <td>{{ record.item }}</td>
                                                <td>{{ record.quantity }}</td>
                                                <td>{{ formatPrice(record.price) }}</td>
                                                <td>{{ formatPrice(record.total) }}</td>
                                                <td>{{ record.site}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDialog from '@/components/common/AlertDialog';
import {formatMoney} from 'accounting';
import PrintDialogSkeleton from '../common/PrintDialogSkeleton';

export default {
    name: "StatementPrintDialog",
    components: {
        AlertDialog,
        PrintDialogSkeleton
    },
    data() {
        return {
            currency: "SDG ",
            decimal: 2,
            display: false,
            printNumber: Math.random(),
            openParams: null,
            showQuantityFlow: false,
            showInvoicesLines: false,
            invoicesLines: [],
            loading: {
                data: true
            },
            statement: {},
            customerSalesOrders: []
           
            
        }
    },
    computed: {
        // ...mapState('sales/customer', ["statement", "customerSalesOrders"])
    },
    methods: {
        ...mapActions('sales/customer', ["fetchCustomerStatement", "resetStatement", 'fetchCustomerSalesOrdersLines', 'fetchCustomerInvoicesLines']),
        formatPrice(amount) {
            return formatMoney(amount, this.currency, this.decimal);
        },
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                await Promise.all([
                    this.fetchCustomerStatement(this.openParams),
                    this.fetchCustomerSalesOrdersLines({ customer_id:  this.openParams.customer_id}),
                    this.fetchCustomerInvoicesLines({ customer_id:  this.openParams.customer_id}),
                ]).then(response => {
                    this.statement = response[0].data;
                    this.customerSalesOrders = response[1].data;
                    this.invoicesLines = response[2].data;
                });
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.alertDialog.open({type: "error", message});
            }
        },
        print() {
            this.$htmlToPaper(this.printNumber);
            this.close();
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
        }
       
    },
}
</script>